var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B492AC"
    },
    d: "M186.309,392.436c-31.027,18.124-54.356,47.979-63.923,83.48 c37.998,22.205,82.008,35.242,129.002,36.044l4.613,0.039l55.351-57.658l-59.964-61.906H186.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B7099"
    },
    d: "M389.615,475.917c-9.567-35.501-32.896-65.356-63.923-83.48l0,0l0,0H186.309 c-12.431,7.261-23.622,16.411-33.191,27.046c10.646,8.443,21.972,15.676,33.801,21.43c14.504,7.056,29.43,11.844,44.599,14.323 c14.056,2.297,24.483,14.254,24.483,28.498V512C304.727,512,350.377,498.847,389.615,475.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#834F86",
      enableBackground: "new"
    },
    d: "M329.802,501.582c9.567-2.768,18.911-6.062,28-9.844 c-4.025-20.328-13.983-38.522-28-52.698V501.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B7099"
    },
    d: "M154.199,491.738c9.089,3.784,18.432,7.077,28,9.844V439.04 C168.183,453.216,158.225,471.409,154.199,491.738z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CF8575"
    },
    points: "209.875,408.472 255.873,454.342 302.127,408.216  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF8575"
    },
    d: "M451.078,197.531c-0.228-0.076-0.458-0.151-0.688-0.224c-0.454-0.143-0.911-0.278-1.37-0.409 c-0.249-0.071-0.497-0.144-0.747-0.212c-0.445-0.12-0.895-0.229-1.345-0.338c-0.261-0.062-0.519-0.13-0.781-0.189 c-0.694-0.156-1.393-0.301-2.099-0.429c-2.239-0.406-4.525-0.678-6.854-0.788c-0.814-0.036-1.632-0.06-2.455-0.06 c-0.957,0-1.907,0.035-2.852,0.085c-3.239,0.176-6.399,0.645-9.452,1.391c-3.923,0.958-7.672,2.362-11.191,4.152 c-0.191-0.726-1.527-5.12-2.824-9.283c-1.224-3.923-5.731-5.751-9.344-3.793l-0.015,0.008 c-15.199-34.018-34.497-53.178-52.783-63.826c-9.913-5.773-19.53-9.051-28.035-10.824c-27.445-5.718-56.978,2.139-75.25,20.013 c-7.361,7.201-12.846,15.285-16.768,24.712c-0.07,0.168-0.137,0.337-0.202,0.506c-5.314,13.998-8.168,31.403-8.834,54.197 c-14.985,6.174-47.961,15.448-79.956-4.498c-2.959-1.845-5.955-4.427-9.154-7.89c-1.929-2.087-3.977-4.043-6.13-5.858 c-7.291-6.152-18.533-2.834-21.141,6.342c-0.018,0.065-0.032,0.116-0.044,0.157c-0.002,0.009-0.005,0.017-0.007,0.027 l97.511,217.08c17.929,8.72,37.39,13.697,57.734,13.697c73.75,0,135.946-65.232,155.246-138.24 c8.07,4.106,17.347,6.181,27.171,5.499c26.066-1.808,46.952-23.204,48.157-49.303C487.684,225.226,472.463,204.621,451.078,197.531 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1A996"
    },
    d: "M382.848,235.243c0-4.501-0.194-9.017-0.556-13.535c-4.322-2.296-9.157-6.498-12.29-14.222 c-14.089-34.711-34.426-55.745-58.815-60.827c-18.731-3.902-35.594,2.651-44.001,10.875c-4.014,3.928-6.774,7.956-8.917,13.028 c-4.528,12.085-6.638,28.803-6.638,52.571c0,6.102-3.215,11.752-8.46,14.87c-1.679,0.997-28.358,16.489-63.599,16.489 c-12.291,0-25.624-1.898-39.302-6.944c-6.394-2.359-11.141-7.712-12.912-14.294c-3.849-14.305-13.658-26.165-26.601-32.754 c-0.001,0.002-0.001,0.006-0.002,0.008c-1.734-0.882-3.525-1.669-5.363-2.356c-0.06-0.022-0.119-0.045-0.179-0.067 c0.06,0.022,0.119,0.045,0.179,0.067c-0.967-0.362-1.947-0.698-2.941-1.003c0.001,0,0.002,0.001,0.002,0.001 c-0.001,0-0.002-0.001-0.002-0.001c-1.862-0.571-3.771-1.036-5.716-1.396c-0.196-0.037-0.394-0.067-0.592-0.1 c-1.959-0.34-3.954-0.573-5.983-0.685c0.283,0.016,0.56,0.04,0.841,0.061c-0.28-0.02-0.559-0.045-0.841-0.061 c-0.961-0.052-1.926-0.085-2.899-0.085c-0.823,0-1.641,0.024-2.455,0.062c-0.306,0.014-0.609,0.039-0.913,0.059 c0.304-0.02,0.608-0.044,0.913-0.059c-0.803,0.037-1.598,0.097-2.392,0.171c-0.386,0.036-0.77,0.078-1.153,0.123 c0.384-0.045,0.768-0.088,1.153-0.123c-27.297,2.53-48.468,26.194-46.971,54.48c1.375,25.963,22.228,47.158,48.165,48.946 c9.818,0.677,19.09-1.4,27.157-5.507c13.976,52.866,50.437,101.653,97.501,124.547c7.559,1.411,15.282,2.167,23.139,2.167 C310.568,419.748,382.848,324.405,382.848,235.243z M60.224,197.76c2.495-0.867,5.077-1.548,7.731-2.027 C65.304,196.216,62.72,196.892,60.224,197.76z M68.776,195.585c0.442-0.073,0.886-0.137,1.331-0.2 C69.662,195.448,69.218,195.511,68.776,195.585z M83.084,195.218c0.287,0.032,0.572,0.067,0.857,0.104 C83.656,195.285,83.371,195.251,83.084,195.218z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#BE6054",
      enableBackground: "new"
    },
    cx: 434.739,
    cy: 246.775,
    r: 17.297
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF8575"
    },
    cx: 77.262,
    cy: 246.775,
    r: 17.297
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M313.643,206.099c-6.293,0-12.581-0.994-18.693-2.984c-4.541-1.478-7.025-6.36-5.547-10.901 c1.479-4.543,6.361-7.026,10.902-5.547c8.721,2.84,17.958,2.838,26.709-0.005c4.536-1.476,9.422,1.009,10.897,5.552 c1.476,4.542-1.01,9.421-5.552,10.897C326.236,205.104,319.937,206.099,313.643,206.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M273.298,255.423h-34.595c-4.776,0-8.649,3.872-8.649,8.649s3.872,8.649,8.649,8.649h34.595 c4.778,0,8.649-3.872,8.649-8.649S278.076,255.423,273.298,255.423z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#474641"
    },
    cx: 198.343,
    cy: 246.775,
    r: 17.297
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#474641"
    },
    cx: 313.658,
    cy: 246.775,
    r: 17.297
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF8575"
    },
    d: "M198.343,281.369c-19.075,0-34.595-15.519-34.595-34.595c0-4.776,3.871-8.649,8.649-8.649 c4.778,0,8.649,3.872,8.649,8.649c0,9.538,7.76,17.297,17.297,17.297c4.778,0,8.649,3.872,8.649,8.649 S203.121,281.369,198.343,281.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF8575"
    },
    d: "M313.658,281.369c-4.778,0-8.649-3.872-8.649-8.649s3.871-8.649,8.649-8.649 c9.538,0,17.297-7.76,17.297-17.297c0-4.776,3.871-8.649,8.649-8.649c4.777,0,8.649,3.872,8.649,8.649 C348.253,265.85,332.734,281.369,313.658,281.369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#978574"
    },
    d: "M287.15,45.699c0.036-0.093,0.06-0.157,0.06-0.157L287.15,45.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#978574"
    },
    d: "M287.084,45.871l0.066-0.172C287.131,45.747,287.11,45.801,287.084,45.871z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#827061"
    },
    d: "M434.738,194.883c-0.039-41.224-16.542-78.539-43.213-105.553 c-26.692-27.058-63.575-43.789-104.315-43.789L213.066,77.45l29.128,86.714c3.225-7.75,7.494-13.709,12.896-18.994 c25.439-24.885,94.536-33.88,130.941,55.813c4.492,11.071,14.69,5.271,22.954,0.75c7.591-4.351,16.379-6.85,25.756-6.85 L434.738,194.883L434.738,194.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#827061"
    },
    d: "M230.262,1.719C145.523,25.854,77.336,102.55,77.263,194.883h-0.001 c15.069,0,28.633,6.429,38.111,16.688c3.794,4.106,7.963,7.873,12.708,10.83c52.46,32.705,106.253,0.733,106.253,0.733 c0-28.118,2.891-45.877,7.861-58.971C253.55,134.245,287.21,45.541,287.21,45.541C287.21,15.449,258.861-6.435,230.262,1.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#978574",
      enableBackground: "new"
    },
    d: "M370.595,131.114c5.286,4.901,10.272,10.382,14.946,16.426 c11.091,14.341,28.538,22.06,46.657,21.466c0.102-0.003,0.203-0.007,0.306-0.009c0.339,1.96,0.638,3.935,0.902,5.92 c-4.411-33.235-19.59-63.009-41.88-85.586c-15.206-15.413-33.721-27.468-54.37-34.996c-3.628,9.562-8.2,21.61-12.965,34.166 c-3.013,7.939,1.151,16.748,9.155,19.585c0.045,0.016,0.09,0.032,0.134,0.047C346.861,112.947,359.301,120.644,370.595,131.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#978574"
    },
    d: "M230.262,1.719c-31.679,9.022-61.042,25.392-85.398,47.178 c-41.243,36.892-46.319,99.677-12.001,143.086l0,0c1.373,1.738,2.845,3.399,4.468,4.906c1.56,1.446,3.042,2.603,4.478,3.498 c21.326,13.295,43.237,12.063,58.637,8.262c4.863-1.2,8.405-5.376,8.778-10.37c1.293-17.343,4.117-31.21,8.714-43.32 c0.097-0.255,54.891-142.785,54.891-142.785C261.915,1.929,246.131-2.806,230.262,1.719z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.6bca67f74fea8da3d8f95dc39a518d64.svg";
export { ForwardRef as ReactComponent };